import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    managers:[],
    loading: false,
}

const managerSlice = createSlice({
  name: "manager",
  initialState: initialState,
  reducers: {
    setmanagers(state, value) {
      state.managers = value.payload;
    },
    setLoading(state, value) {
      state.loading = value.payload;
    }
  },
});

export const { setmanagers, setLoading} = managerSlice.actions;

export default managerSlice.reducer;